import { useCallback, useState } from 'react';

interface UseFilterSheetProps<T = any> {
  onApplyFilters: (data: T) => void;
}

export const useFilterSheet = <T = any>({ onApplyFilters }: UseFilterSheetProps<T>) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => {
    console.log('Opening filter sheet');
    setIsOpen(true);
  }, []);

  const handleCancel = useCallback(() => {
    console.log('Canceling filter sheet');
    setIsOpen(false);
  }, []);

  const handleApplyAndClose = useCallback(
    (data: T) => {
      console.log('Applying filters and closing sheet:', data);
      onApplyFilters(data);
      setIsOpen(false);
    },
    [onApplyFilters],
  );

  return {
    isOpen,
    setIsOpen,
    handleOpen,
    handleCancel,
    handleApplyAndClose,
  };
};
